export enum DeviceConnectionType {
  PLC = 'plc',
  RS485 = 'rs485',
  W_MODBUS = 'wmodbus'
}
